import { VH, VW } from "../../../tiles";
import { floodFill } from "../../../ui/helpers";
import { TextButton } from "../../../ui/input/TextButton";
import { setScene } from "../../../ui/scene";
import { ALIGN_TYPE, TextType } from "../../../ui/type/TextType";
import { ComponentF, createElement } from "../../../ui/ui";
import Colors from "../../Colors";
import { GameScene } from "../../scenes/game";
import { HelpComponent } from "./helpComponent";

export const HomeComponent: ComponentF<void> = (C) => {
  floodFill(C.display, { x: 0, y: 0, w: 12, h: 4 }, Colors.DEEP_BLUE);
  floodFill(C.display, { x: VW - 12, y: 0, w: 12, h: 4 }, Colors.DEEP_BLUE);
  floodFill(C.display, { x: 0, y: VH - 4, w: 12, h: 4 }, Colors.DEEP_BLUE);
  floodFill(
    C.display,
    { x: VW - 12, y: VH - 4, w: 12, h: 4 },
    Colors.DEEP_BLUE
  );

  return [
    createElement(
      TextType,
      { x: 0, y: 3, w: C.bounds.w, h: C.bounds.h },
      { title: "SPELLGEON", align: ALIGN_TYPE.center }
    ),
    createElement(HelpComponent, {
      x: 7,
      y: 6,
      w: C.bounds.w - 14,
      h: C.bounds.h - 10,
    }),
    createElement(
      TextButton,
      { x: C.bounds.w / 2 - 8, y: C.bounds.h - 2, w: 16, h: 1 },
      {
        keys: "Enter",
        title: "Start Game",
        keyLabel: "Enter",
        onClick: () => {
          setScene(new GameScene());
        },
      }
    ),
  ];
};
